import { lazy, Suspense, useEffect, useState } from 'react';

declare global {
    interface Window {
        toggleDevtools: () => void;
    }
}

const LazyReactQueryDevtools = lazy(async () =>
    import(
        /* webpackChunkName: "react-query-devtools" */ '@tanstack/react-query-devtools/build/modern/production.js'
    ).then((d) => ({ default: d.ReactQueryDevtools }))
);

interface ReactQueryDevtoolsProps {
    initialVisibility: boolean;
}

export const ReactQueryDevtools = ({ initialVisibility }: ReactQueryDevtoolsProps) => {
    const [showDevtools, setShowDevtools] = useState(initialVisibility);

    useEffect(() => {
        window.toggleDevtools = () => setShowDevtools((old) => !old);
    }, []);

    return (
        <>
            {showDevtools && (
                <Suspense fallback={null}>
                    <LazyReactQueryDevtools initialIsOpen={false} />
                </Suspense>
            )}
        </>
    );
};
